<div class="bg-gray-50 dark:bg-gray-950 text-gray-800 dark:text-gray-200 font-sans flex flex-col h-screen overflow-hidden">
  <app-header (menuToggle)="mobileOpen.set(!mobileOpen())"></app-header>
  <div class="flex flex-1 overflow-hidden">
    <app-sidebar [mobileOpen]="mobileOpen()" (mobileClose)="mobileOpen.set(false)"></app-sidebar>
    <main class="bg-gray-50 dark:bg-gray-950 flex-1 overflow-y-auto">
      <router-outlet></router-outlet>
    </main>
  </div>
</div>
